module.exports = __webpack_public_path__ + "static/img/no-result@3x.fbd95c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/base/page-loadfail/no-result@3x.png
// module id = 4x3Z
// module chunks = 22